export const VERTICAL_NAMES = {
  homes: 'homes',
  cars: 'cars',
  jobs: 'jobs',
  products: 'products',
};

export const VERTICAL_IDS = {
  homes: 1,
  cars: 2,
  jobs: 4,
  products: 8,
};

export const READING_DIRECTIONS = {
  ltr: 'ltr',
  rtl: 'rtl',
};

export const MOBILE_PLATFORMS = {
  ios: 'ios',
  android: 'android',
};

export const DOWNLOAD_APPS_ATTRIBUTION_BASE_URLS = {
  homes: 'https://z3tru.app.goo.gl/?apn=es.roid.and.trovit&isi=347012986&ibi=com.trovit.casas',
  cars:
    'https://rdf7k.app.goo.gl/?apn=com.trovit.android.apps.cars&isi=558532549&ibi=com.trovit.cars',
  jobs:
    'https://ma99c.app.goo.gl/?apn=com.trovit.android.apps.jobs&isi=379240463&ibi=com.trovit.jobs',
};



// WEBPACK FOOTER //
// ./app/common/constants/common.js